// Module
var code = "<div> <div class=\"name\">{{ filterLabel }} Filters</div> <div class=\"pad-bottom12\"> <filters :filter-container.sync=\"proxyFilter\" :readonly=\"true\"></filters> </div> </div>";
// Exports
export default code;